import NoteContext from "./noteContext";
import { useState } from "react";

const NoteState = (props) => {
  const host = "https://inotebook-mern-swxw.onrender.com";
  //const host = "http://localhost:5000";
  const [notes, setNotes] = useState([]);

  // 🔹 Get all Notes (USER SPECIFIC)
  const getNotes = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.log("❌ No token found, skipping getNotes");
        setNotes([]);
        return;
      }

      const response = await fetch(`${host}/api/notes/fetchallnotes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });

      const json = await response.json();
      console.log("✅ NOTES FROM API 👉", json);

      // 🛡️ SAFETY CHECK
      if (Array.isArray(json)) {
        setNotes(json);
      } else {
        console.error("❌ Notes API did not return array:", json);
        setNotes([]);
      }
    } catch (error) {
      console.error("❌ Error fetching notes:", error);
      setNotes([]);
    }
  };

  // 🔹 Add a Note
  const addNote = async (title, description, tag) => {
    try {
      const response = await fetch(`${host}/api/notes/addnote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify({ title, description, tag }),
      });

      const note = await response.json();
      console.log("➕ Added note:", note);

      if (note && note._id) {
        setNotes((prev) => prev.concat(note));
      }
    } catch (error) {
      console.error("❌ Error adding note:", error);
    }
  };

  // 🔹 Delete a Note
  const deleteNote = async (id) => {
    try {
      await fetch(`${host}/api/notes/deletenote/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      });

      setNotes((prev) => prev.filter((note) => note?._id !== id));
    } catch (error) {
      console.error("❌ Error deleting note:", error);
    }
  };

  // 🔹 Edit a Note
  const editNote = async (id, title, description, tag) => {
    try {
      await fetch(`${host}/api/notes/updatenote/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify({ title, description, tag }),
      });

      // 🛡️ Update notes in UI safely
      setNotes((prevNotes) =>
        prevNotes.map((note) =>
          note?._id === id
            ? { ...note, title, description, tag }
            : note
        )
      );
    } catch (error) {
      console.error("❌ Error editing note:", error);
    }
  };

  return (
    <NoteContext.Provider
      value={{ notes, addNote, deleteNote, editNote, getNotes }}
    >
      {props.children}
    </NoteContext.Provider>
  );
};

export default NoteState;
